export default {
  common: {
    clearAll: 'مسح الكل',
    restart: 'إعادة التشغيل'
  },
  download: {
    bodyText: 'انقر على رابط التحميل أدناه لتنزيل %{products}',
    bothProducts: 'PlayBase و/أو Nexus',
    bodyTextFromAcceptInvitation:
      'سيستغرق العملية بعض الوقت. في غضون ذلك، يمكنك الاستمرار في استخدام Metrica Sports كالمعتاد.',
    bodyTextFromDeclineInvitation:
      'لقد رفضت الدعوة! انقر على رابط التحميل أدناه لتحميل %{products}',
    bodyTextFromTrial:
      'مرحبًا بك في إعداد الفترة التجريبية الخاصة بك! تحقق من بريدك الإلكتروني المسجل للحصول على رابط التحقق (تحقق من مجلد البريد العشوائي).',
    bodyTitle: 'تحميل',
    bodyTitleFromAcceptInvitation: 'نحن نقوم بتغيير حسابك',
    bodyTitleFromDeclineInvitation: 'دعوة مرفوضة',
    bodyTitleFromTrial: 'اكتمل التسجيل',
    play2: {
      description:
        'Metrica PlayBase هي أداة تحليل بديهية مصممة للمدربين الهواة والمحترفين، الأندية الصغيرة، والمحللين المستقلين. تبسط عملية تقييم الأداء، مما يجعلها متاحة للجميع.',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    play3: {
      description:
        'Metrica Nexus مصمم للمحللين والمدربين من النخبة الذين يبحثون عن معلومات شاملة حول الأداء. مع أدوات متقدمة في متناول يدك، يمكنك تحسين استراتيجيات الفريق وتحقيق النجاح.',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    thanks: 'شكرًا لتسجيلك في Metrica Sports! للبدء بتجربتك، قم بتحميل %{products}.'
  },
  error: {
    restart: 'يبدو أنك تحاول الدخول في شيء ما زلنا نطوره...',
    tryAgainMsg: 'يرجى المحاولة مرة أخرى، إذا استمر هذا الخطأ، اتصل بفريق الدعم'
  },
  verifyEmail: {
    generateLink: 'إنشاء رابط جديد عن طريق تسجيل الدخول إلى Play',
    readyToLogin: 'أنت جاهز لتسجيل الدخول إلى Play',
    successfully: 'تم التحقق من البريد الإلكتروني بنجاح',
    unsuccessfully: 'خطأ في التحقق من البريد الإلكتروني ، رمز غير صالح'
  }
}
